import { render, staticRenderFns } from "./brand-article-detail.vue?vue&type=template&id=733e1856&scoped=true&"
import script from "./brand-article-detail.vue?vue&type=script&lang=js&"
export * from "./brand-article-detail.vue?vue&type=script&lang=js&"
import style0 from "./brand-article-detail.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./brand-article-detail.vue?vue&type=style&index=1&id=733e1856&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733e1856",
  null
  
)

export default component.exports